"use client";

import Link from "next/link";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { usePathname } from "next/navigation";

export function ViewSelector() {
  const pathname = usePathname();

  return (
    <Tabs value={pathname}>
      <TabsList>
        <TabsTrigger asChild value="/">
          <Link
            className="data-[state=active]:text-primary-text data-[state=active]:font-bold"
            href="/"
          >
            Calendario
          </Link>
        </TabsTrigger>
        <TabsTrigger asChild value="/activities">
          <Link
            className="data-[state=active]:text-primary-text data-[state=active]:font-bold"
            href="/activities"
          >
            Actividades
          </Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
